<template>
  <div>
    <el-row type="flex" justify="center">
      <el-col v-for="(item) in videoList" :key="item.src" :xs="24" :md="12">
        <VideoPlayer :url="item.srcToken" :title="item.name" :data="item"></VideoPlayer>
      </el-col>
      <el-col v-if="videoList.length == 0" :span="24">
        <div class="share-expired-tip">
          <span>链接已失效</span>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import VideoPlayer from '@/components/VideoPlayer';
import ShareApi from '@/api/share'
export default {
  components: {
    VideoPlayer
  },
  props: {},

  data() {
    return {
      videoList: [

      ]
    };
  },
  computed: {},
  methods: {
    initData() {
      const id = this.$route.params.id
      if (!id) return
      ShareApi.fetchGetShareById(id).then(res => {
        console.log(res)
        if (res.code === 200) {
          let data = res.data
          if (typeof data === 'string') {
            //todo
          } else {
            if (data) {
              let content = data.content

              if (content) {
                content = JSON.parse(content)

                if (content.videoList) {
                  this.videoList = content.videoList
                }
              }
            }
          }
        }
      })
    }
  },
  mounted() {
    this.initData()
  },
};
</script>


<style lang="scss" scoped>
.share-expired-tip {
  padding: 40px;
  color: #909399;
  text-align: center;
}
</style>